import React from "react";
import { MessageCircle } from "lucide-react";
import { dataTrigger } from "@/analytics";
import { CancelSubscription } from "@/features/CancelSubscription/CancelSubscription";
import { ResumeSubscription } from "@/features/ResumeSubscription/ResumeSubscription";
import { Button } from "@/ui/Button/Button";
import {
  useMainActionsContext,
  useMainSubscriptionContext,
} from "../MainPageContext";
import cls from "../styles.module.scss";

export function ActionsBlock() {
  const { isPaid, isCancelled, isPromo } = useMainSubscriptionContext();
  const { onSupport } = useMainActionsContext();

  return (
    <div className={cls.actionsBlock}>
      {isPaid && (
        <Button
          variant="secondary"
          size="md"
          onClick={onSupport}
          leftIcon={<MessageCircle />}
          {...dataTrigger("bkn.main.support")}
        >
          Поддержка в Telegram
        </Button>
      )}

      {isPaid && !isCancelled && !isPromo && <CancelSubscription />}
      {isPaid && isCancelled && <ResumeSubscription />}
    </div>
  );
}
